export const EXTRA_CONFIGURATION_TOGGLE_KEYS = ["exportAsSubscribed"]


// WEBPACK FOOTER //
// ./src/utils/integration/mailchimp/constants.ts